import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { GspClaimReason, GspReasonLabels } from '~/utils/constants';
import {
  makeShippingProtectionClaimAction,
  makeShippingProtectionClaimLoader,
  redirect,
} from '~/utils/routing';

export const { loader, useLoaderData } = makeShippingProtectionClaimLoader(
  ({ context }) => ({
    reasons: context.order.shippingClaimReasons.map((reason) => ({
      value: reason,
      label: GspReasonLabels[reason],
    })),
    selectedReason: context.shippingProtectionClaim.reason,
  }),
);

const formSchema = zfd.formData({
  reason: zfd.text(z.nativeEnum(GspClaimReason)),
});

export const { action, useActionResult } = makeShippingProtectionClaimAction(
  ({ context, formData }, appStore) => {
    const result = formSchema.safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Please choose one of the reasons.',
      };
    }

    appStore.dispatch(
      appStore.actions.shippingProtectionClaim.setReason(result.data.reason),
    );

    const shippingClaimAction =
      context.order.shippingClaimReasonOverrides?.find(
        (override) => override.reason === result.data.reason,
      );

    const url = shippingClaimAction ? 'shipping-issue' : 'items';

    return redirect(url);
  },
);
